<app-autocomplete
  #autocompleteComponent
  (term)="onTermUpdate($event)"
  [data]="data"
  (activeItem)="currentActive = $event"
  (itemSelected)="onItemSelected($event)"
>
  <ng-content></ng-content>
  <ul class="list-group" options>
    <li class="list-group-item" #autocompleteItem  [ngClass]="{'active' : currentActive == item}" *ngFor="let item of data"
        (click)="onItemSelected(item)"
    >{{getItemDescription(item)}}
      <small class="text-muted" *ngIf="getMail(item)"><br> ( {{getMail(item)}})</small>
    </li>
  </ul>
</app-autocomplete>


